import React, { Component } from "react";
import PropTypes from "prop-types";
import { Tab, Tabs, Button, NumericInput, Checkbox, Switch  } from "@blueprintjs/core";
import { loadImagerParameter, createImageFromTempArray } from "../tools/jsprocedure"
import "./Viewer.css";
import WebNetRoiTable  from "./WebNetRoiTable";
import  ViewerAnimalsTable  from "./ViewerAnimalTable";
import WebNetComments from "./WebNetComments";
import UploadImages from "./Upload-images"
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import ColorMaps from "./ColorMaps";
import jimp  from "jimp";
import MainImage from "./MainImage";
import Thermometer from "./Thermometer";
import ThermometerHorsz from "./ThermometerHorz";
import ZoomSlider from "./ZoomSlider";
import ColorMapImagePreview from "./ColorMapImagePreview";
import WebNetCameraParms from "./WebNetCameraParms"
import _ from "lodash";
import { withTranslation  } from 'react-i18next';

import saveReportPDF from "./PrintReport";
import ReportComment from "./ReportComment";

const corlormapUrl = process.env.REACT_APP_API_COLORMAP;

class Viewer extends Component  {

    constructor(props) {
        super(props);
        this.state = {

            selected: "ROI-Table",

            min_min: -30.00,
            min_max: 80.00,
            min_value: -30.00,
            isMinValueFromScale: false,

            max_min: -30.00,
            max_max: 80.00,
            max_value: 80.00,
            isMaxValueFromScale: false,

            imBuffer: [],
            imagePixels: null,
            newImage: null,

            zoomValue: 1.00,
            isVisualImage: false,
            newImageState: "",


            hasVisualImage: false,
            colorMapSelectedCode64: "",
            isDraggable: true,
            thumbnailsData: [],
            imageChange: false,

            selectedROI: "",

            indexSelectedROI: 0,

            isCelsiusImg: true, // True - celsius, False - Fahrenhei

            comment: "",
            modalIsOpen: false,
            reporter: "",
        };
        this.calculateTemperatureValue = this.calculateTemperatureValue.bind(this);

        this.handleValueChangeMax = this.handleValueChangeMax.bind(this);
        this.handleValueChangeMin = this.handleValueChangeMin.bind(this);
        this.handleValueChangeMinInput = this.handleValueChangeMinInput.bind(this);
   

        this.debouncedhandleValueChangeMax = _.debounce(this.handleValueChangeMax, 5);
        this.debouncedhandleValueChangeMin = _.debounce(this.handleValueChangeMin, 5);
        this.debouncedCalculateTemperatureValue = _.debounce(this.calculateTemperatureValue, 200);
        this.debouncedHandleResizeChange = _.debounce(this.handleResizeChange, 5);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const { handleAnimals, fetchColorMaps, animals, colorMapSelected, colorMap, handleColorMapSelected,
            selectedImagesThumbnailData, selectedImagesThumbnail, isFirstSearching, isCelsius, user } = this.props;

        const { min_min, min_value, max_max, max_value } = this.state;

        // Use to avoid render after login. at login added e.preventDefault
        if (animals.length == 0 && isFirstSearching) {
            handleAnimals("user");   // TODO:USER logger
            fetchColorMaps();
        }

        //let tempType = localStorage.getItem("TemperatureType");


        //localStorage.setItem("TemperatureType", true);  // Celsius



        if (selectedImagesThumbnail !== "") {
            if (colorMap.length === 0) handleColorMapSelected(colorMapSelected);
            //this.setState({ newImageState: selectedImagesThumbnail });
            //this.getColorMapImage(colorMapSelected);

            if (selectedImagesThumbnailData.length > 0) {

                this.setState({
                    min_value: isCelsius ? selectedImagesThumbnailData[0].mintemperaturescale : Number(Math.round(selectedImagesThumbnailData[0].mintemperaturescale * 1.8 + 32  + 'e1') + 'e-1') ,
                    min_min: isCelsius ? -30.00 : -22 ,
                    max_value: isCelsius ? selectedImagesThumbnailData[0].maxtemperaturescale : Number(Math.round(selectedImagesThumbnailData[0].maxtemperaturescale  * 1.8 + 32 + 'e1') + 'e-1')  ,
                    max_max: isCelsius ? 80.00 : 176.00,
                    image_width: selectedImagesThumbnailData[0].width,
                    image_height: selectedImagesThumbnailData[0].height,
                    hasVisualImage: selectedImagesThumbnailData[0].visualimagedata != null ? true : false,
                    imageChange: true,
                    isCelsiusImg: isCelsius,
                    reporter: user.username,
                });
                this.debouncedCalculateTemperatureValue();
            };
        } else { 
            let min_min1 = !isCelsius ? Number(Math.round(min_min * 1.8 + 32 + 'e1') + 'e-1') : min_min;
            let max_max1 = !isCelsius ? Number(Math.round(max_max * 1.8 + 32 + 'e1') + 'e-1') : max_max;
            let minTempValue = !isCelsius ? Number(Math.round(min_value * 1.8 + 32 + 'e1') + 'e-1') : min_value;
            let maxTempValue = !isCelsius ? Number(Math.round(max_value * 1.8 + 32 + 'e1') + 'e-1') : max_value;
            this.setState({ min_min: min_min1, min_value: minTempValue, max_max: max_max1, 
                max_value: maxTempValue, isCelsiusImg: isCelsius,
                reporter: user.username,});
            if (colorMap.length === 0) handleColorMapSelected(colorMapSelected);
            
        }

    }

    handleAnimalSelectHere = (handleMessage, animal) => {
        this.handleMessage(animal);
    }

    handleTabChange = (id) => {
        this.setState({ selected: id });
    }

    handleSearchColorMap = () => {

    }

    handleValueChangeMax = (valueAsNumber, valueAsString) => {

        const { max_max, min_value } = this.state;
        if (valueAsNumber <= max_max && valueAsNumber >= min_value) {

            this.setState({
                min_max: valueAsNumber, max_value: valueAsNumber, isMaxValueFromScale: true
            }, () => {
                //this.calculateTemperatureValue();
                this.debouncedCalculateTemperatureValue();
            });
        } else {
            if (valueAsNumber > max_max)
                this.setState({ max_value: max_max, isMaxValueFromScale: true, });

        }

    };

    handleValueChangeMin = (valueAsNumber, valueAsString) => {
        const { min_max, min_min, } = this.state;
        if (valueAsNumber <= min_max && valueAsNumber >= min_min) {
            this.setState({
                max_min: valueAsNumber, min_value: valueAsNumber, isMinValueFromScale: true
            }, () => {
                //this.calculateTemperatureValue();
                this.debouncedCalculateTemperatureValue();
            });

        } else {
            if (valueAsNumber > min_max) {
                this.setState({ min_value: min_max, isMinValueFromScale: true, });
            }
        }
    };

    handleValueChangeMinInput = (event) => {
        //console.log(event.target.value);
        //this.handleValueChangeMin(event.target.value); 
        this.debouncedhandleValueChangeMin(event.target.value);
    };


    // create the visual image based on image visualimagedata and ZoomValue    
    visualImage = () => {
        const { selectedImagesThumbnailData, } = this.props;
        const imageData = selectedImagesThumbnailData[0].visualimagedata;
        const imageBuffer = new Buffer.from(imageData, 'base64')

        jimp.read(imageBuffer, (err, res) => {
            if (err) throw new Error(err);
            let sizex = Math.round(res.bitmap.width * this.state.zoomValue);
            let sizey = Math.round(res.bitmap.height * this.state.zoomValue);
            res.resize(sizex, sizey);

            //console.log(this.state.zoomValue);
            res.getBase64Async("image/png").then((response) => {
                this.setState({ imagePixels: res, newImageState: response, imBuffer: imageBuffer, isVisualImage: true, })
            });

        });
        //}
    }

    /* Create matrix pixel
     * imBuffer: 
    */
    calculateTemperatureValue = () => {
        //console.log("calculate temperature");
        const { imBuffer, min_value, max_value, isMinValueFromScale, zoomValue, isMaxValueFromScale, imageChange, isCelsiusImg} = this.state;
        const { selectedImagesThumbnailData, colorMap, isCelsius } = this.props;
        if ((selectedImagesThumbnailData.length > 0)) {

            let sizex = selectedImagesThumbnailData[0].width;
            let sizey = selectedImagesThumbnailData[0].height;

            // convert Temperature to Celsius always to get the thermal image
            let minTempValue = !isCelsius ? Number(Math.round((min_value - 32) * 0.5556 + 'e1') + 'e-1') : min_value;
            let maxTempValue = !isCelsius ? Number(Math.round((max_value - 32) * 0.5556 + 'e1') + 'e-1') : max_value;

            if (isCelsiusImg !== isCelsius) {
                minTempValue = !isCelsiusImg ? Number(Math.round((min_value - 32) * 0.5556 + 'e1') + 'e-1') : min_value;
                maxTempValue = !isCelsiusImg ? Number(Math.round((max_value - 32) * 0.5556 + 'e1') + 'e-1') : max_value;
            }

            //let MinMinValue = !isCelsius ? Number(Math.round(min_min * 1.8 + 32 + 'e1') + 'e-1') : min_min;
            //let MaxMaxValue = !isCelsius ? Number(Math.round(max_max * 1.8 + 32 + 'e1') + 'e-1') : max_max;


            let imagePixels = new jimp(sizex, sizey);
            let image = this.createImageFromTempArray(imBuffer, imagePixels, sizex, sizey, colorMap, minTempValue, maxTempValue, isCelsius, isCelsiusImg);
            let loadedImage = document.getElementById("loadedImage");

            let startZoom = 1;
            let percentX = loadedImage.offsetWidth / sizex;
            let percentY = loadedImage.offsetHeight / sizey;

            if ((zoomValue == 1 && imageChange)) {
                //console.log(zoomValue);
                if (percentX > percentY) {
                    startZoom = percentY;
                } else {
                    startZoom = percentX;
                }
            }

            let zoomValueNew = startZoom * zoomValue;
            sizex = sizex * zoomValueNew;
            sizey = sizey * zoomValueNew;
            image.resize(sizex, sizey);
            image.getBase64Async("image/png")
                .then((response) => this.setState({
                    imagePixels: image,
                    zoomValue: zoomValueNew,
                    newImageState: response,
                    isVisualImage: false,
                    //min_min: MinMinValue,
                    //max_max: MaxMaxValue,
                    imageChange: false,
                })
                );
        }
    }

    // Create Image from Temperature imBuffer array
    createImageFromTempArray = (imBuffer, image, sizex, sizey, colorMap, scaleMin, scaleMax, isCelsius, isCelsiusImg) => {
        //if (imBuffer.length == 0 ) return null;

        const { selectedImagesThumbnailData, } = this.props;

        let numColors = colorMap.length;

        imBuffer = loadImagerParameter(selectedImagesThumbnailData[0].imagedata);


        let offset = (scaleMax - scaleMin) !== 0 ? scaleMax - scaleMin : 0.001;  // avoid undefined value

        for (let y = 0; y < sizey; y++) {
            for (let x = 0; x < sizex; x++) {
                let temp = imBuffer[(sizex) * y + x] - 273.15;

                if (temp > scaleMax)
                    temp = scaleMax;
                if (temp < scaleMin)
                    temp = scaleMin;

                let index = Math.round(Math.min((numColors * (temp - scaleMin)) / (offset), numColors - 1));
                image.setPixelColor(jimp.rgbaToInt(colorMap[index].r, colorMap[index].g, colorMap[index].b, 255), x, y);
            }
        }
        this.setState({ imBuffer: imBuffer });
        return image;
    }

    // ZoomValueIn =  percentValue + old recent ZoomValue
    handleResizeChange = (zoomValue) => {
        let newZoom = zoomValue / 100;
        if (!this.state.isVisualImage) {
            //console.log(this.state.isVisualImage);
            this.setState({
                zoomValue: newZoom
            }, () => {
                //this.calculateTemperatureValue();
                this.debouncedCalculateTemperatureValue();
            });
        } else {
            //console.log(this.state.isVisualImage);
            const { selectedImagesThumbnailData, } = this.props;
            const imageData = selectedImagesThumbnailData[0].visualimagedata;
            const imageBuffer = new Buffer.from(imageData, 'base64');

            jimp.read(imageBuffer, (err, res) => {
                if (err) throw new Error(err);

                let sizex = Math.round(res.bitmap.width * newZoom);
                let sizey = Math.round(res.bitmap.height * newZoom);
                res.resize(sizex, sizey);

                res.getBase64Async("image/png").then((response) => {
                    this.setState({ imagePixels: res, newImageState: response, imBuffer: imageBuffer, isVisualImage: true, zoomValue: newZoom })
                });
            });
        }
    }

    // Resize FullImage
    handleFullImageResizeChange = () => {

        const { selectedImagesThumbnailData } = this.props;
        let sizex = selectedImagesThumbnailData[0].width;
        let sizey = selectedImagesThumbnailData[0].height;

        let loadedImage = document.getElementById("loadedImage");

        let startZoom = 1;
        let percentX = loadedImage.offsetWidth / sizex;
        let percentY = loadedImage.offsetHeight / sizey;

        if (percentX > percentY) {
            startZoom = percentY;
        } else {
            startZoom = percentX;
        }

        let newZoom = startZoom;
        if (!this.state.isVisualImage) {
            //console.log(this.state.isVisualImage);
            this.setState({
                zoomValue: newZoom
            }, () => {
                //this.calculateTemperatureValue();
                this.debouncedCalculateTemperatureValue();
            });

        } else {
            //console.log(this.state.isVisualImage);
            const { selectedImagesThumbnailData, } = this.props;
            const imageData = selectedImagesThumbnailData[0].visualimagedata;
            const imageBuffer = new Buffer.from(imageData, 'base64');

            jimp.read(imageBuffer, (err, res) => {
                if (err) throw new Error(err);

                let sizex = Math.round(res.bitmap.width * newZoom);
                let sizey = Math.round(res.bitmap.height * newZoom);
                res.resize(sizex, sizey);

                res.getBase64Async("image/png").then((response) => {
                    this.setState({ imagePixels: res, newImageState: response, imBuffer: imageBuffer, isVisualImage: true, zoomValue: newZoom })
                });
            });
        }
    }

    // get image of ColorMap selected
    getColorMapImage = async (colorName) => {
        const { fetchImage } = this.props
        try {
            let isMounted = true;
            const imageData = await fetchImage(corlormapUrl + colorName + "/png/")
                .then(data => {
                    if (isMounted) this.setState({ colorMapSelectedCode64: data.toString() });
                });
            return () => { isMounted = false };
        } catch (err) {
            console.log(err);
        }
    }


    /**
 * Handle selected ROI - call at ROI-TABLE
 * @param {any} selectedROI
 */
    handleSelectedROI = async (selectedROI, i) => {
        this.setState({ selectedROI: selectedROI, indexSelectedROI: i });
        //console.log("In View: ", selectedROI);
    }

    /**
     * Handle selected ROI and its index order - call at ROI-TABLE
     * @param {any} selectedROI
     * @param {any} i
     */
    handleClickROI = async (selectedROI, i) => {
        this.setState({ selectedROI: selectedROI, indexSelectedROI: i });

        //console.log("selectedROI: ", selectedROI);
        //console.log("ROI selected index: ", i);
    }

    handleIsDraggable = () => {
        this.setState({ isDraggable: !this.state.isDraggable });
    }

    handleReportComment = (value) => {
        this.setState({ comment: value});
    }

    setMaxTemperatureInput(selectedImagesThumbnailData, max_max) {
        if (selectedImagesThumbnailData.length > 0)
            return selectedImagesThumbnailData[0].maxtemperaturescale
        else
            return max_max;
    }

    setMinTemperatureInput(selectedImagesThumbnailData, min_min) {
        if (selectedImagesThumbnailData.length > 0)
            return selectedImagesThumbnailData[0].mintemperaturescale
        else
            return min_min;
    }

    handleReportComment = (value) => {
        this.setState({ comment: value });
    }

    handleReporter = (value) => {
        this.setState({ reporter: value });
    }



    setTempMeasure = () => {
        const { min_min, min_max, min_value, max_min, max_value, max_max, isCelsiusImg} = this.state;


        if (!isCelsiusImg) {
                //localStorage.setItem("TemperatureType", true);  // Celsius
                let min_min1 = Number(Math.round((min_min -32) * 0.5556 + 'e1') + 'e-1');
                let min_max1 =  Number(Math.round((min_max - 32) * 0.5556 + 'e1') + 'e-1');
                let min_value1 = Number(Math.round((min_value - 32) * 0.5556 + 'e1') + 'e-1');
                let max_min1 = Number(Math.round((max_min - 32) * 0.5556 + 'e1') + 'e-1');
                let max_max1 = Number(Math.round((max_max - 32) * 0.5556 + 'e1') + 'e-1');
                let max_value1 = Number(Math.round((max_value - 32) * 0.5556 + 'e1') + 'e-1');
                this.setState({ 
                    isCelsiusImg: !this.state.isCelsiusImg,
                    min_min: min_min1, 
                    min_max: min_max1, min_value: min_value1, max_min: max_min1, 
                    max_value: max_value1, max_max: max_max1 })
            } else {
                //localStorage.setItem("TemperatureType", false);  // Farh.
                let min_min1 = Number(Math.round(min_min * 1.8 + 32 + 'e1') + 'e-1');
                let min_max1 = Number(Math.round(min_max * 1.8 + 32 + 'e1') + 'e-1');
                let min_value1 = Number(Math.round(min_value * 1.8 + 32 + 'e1') + 'e-1');
                let max_min1 =  Number(Math.round(max_min * 1.8 + 32 + 'e1') + 'e-1');
                let max_max1 = Number(Math.round(max_max * 1.8 + 32 + 'e1') + 'e-1');
                let max_value1 = Number(Math.round(max_value * 1.8 + 32 + 'e1') + 'e-1');
                this.setState({
                    isCelsiusImg: !this.state.isCelsiusImg,
                    min_min: min_min1,
                    min_max: min_max1, min_value: min_value1, max_min: max_min1, 
                    max_value: max_value1, max_max: max_max1
                })
            } 
       
    }

    iconTemp = () => {
        const { isCelsiusImg } = this.state;
        return isCelsiusImg ? "\u00B0C" : "\u00B0F"
    }

    handleReportPDF = () => {
        const { selectedImagesThumbnailData, selectedAnimal, colorMapSelectedCode64, t, languageSelected, isCelsius } = this.props;
        const { newImageState, min_value, max_value, zoomValue, comment, reporter } = this.state;
        saveReportPDF(selectedImagesThumbnailData[0], newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelsius, t);
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }
  
    render() {
        const {
            apiCall,
            animals,
            handleAnimalSelect,
            selectedAnimal,
            animalInfoOpen,
            sessionInfoOpen,
            selectedSequence,
            handleOwnerSelect,
            handleSessionSelect,
            handleSequenceSelect,
            imagesThumbnailBySequences,
            thumbnailsData,
            selectedImagesThumbnailData,
            selectedImagesThumbnail,
            handleSelectedImage,
            isExtendedImg,
            imageSize,
            handleColorMapSelected,
            colorMapList,
            colorMapSelected,
            colorMapSelectedCode64,
            fetchImage,
            openList,
            handleOpenList, 

            languageSelected,

            isCelsius,

            user,
 
        } = this.props;

        const { selected, min_min, min_max, max_min, max_max, imBuffer, imagePixels, newImageState, 
            zoomValue, isVisualImage, min_value, max_value, hasVisualImage, selectedROI, indexSelectedROI, isCelsiusImg, comment, reporter
        } = this.state;

        //const isCelsius = localStorage.getItem("TemperatureType");

        const spreadPatientList = {
            handleAnimalSelect, handleOwnerSelect, handleSessionSelect, handleSequenceSelect, animals, animalInfoOpen, sessionInfoOpen, 
            selectedSequence, languageSelected
        };

        const isActiveTempImage = !isVisualImage && selectedImagesThumbnailData.length > 0 ? true : false;
        const roisArray = isActiveTempImage ? selectedImagesThumbnailData[0].rois : [];
        const notesArray = isActiveTempImage ? selectedImagesThumbnailData[0].notes : [];
        const isImagePixelsLoaded = imagePixels !== null ? true : false;
        const rangeValue = [min_value, max_value];

        const thumbnailsDataConst = { thumbnailsData, imagesThumbnailBySequences, selectedImagesThumbnail, handleSelectedImage, languageSelected  }

        const { t } = this.props;

        return (
            <div id="general" className="general">
                {!isExtendedImg || openList ?
                    < div className={openList ? "LeftDiv" : !isExtendedImg ? "LeftDiv" : "LeftDivRestricted"}  >
                        <div className="patientData">
                            <ViewerAnimalsTable {...spreadPatientList} />
                        </div>
                        <div className="tabs" >
                            <Tabs renderActiveTabPanelOnly="true" onChange={this.handleTabChange} selectedTabId={selected}>
                                <Tab
                                    key={1}

                                    id={"ROI-Table"}
                                    title={<div className="tab-header"><span>{t("Analysis")}</span> <div></div></div>}
                                    panel={
                                        <div className="roiData">
                                            {isActiveTempImage ? 
                                                <WebNetRoiTable 
                                                    rois={selectedImagesThumbnailData[0].rois}
                                                    apiCall={apiCall}
                                                    selectedROI={selectedROI}
                                                    handleSelectedROI={this.handleSelectedROI}
                                                    indexSelectedROI={indexSelectedROI}
                                                    handleClickROI={this.handleClickROI}
                                                    isCelsius={isCelsius}
                                                    isCelsiusImg={isCelsiusImg}
                                                    
                                                  /> 
                                                : 
                                                t("No image selected")}
                                        </div>
                                    }
                                />
                                <Tab
                                    key={2}

                                    id="Comments"
                                    title={<div className="tab-header"><span>{t("Comments")}</span> </div>}
                                    panel=

                                    {selectedAnimal !== {} ? <WebNetComments id={selectedAnimal.id} apiCall={apiCall} /> :  t("No image selected") }
                                />
                                <Tab
                                    key={3}

                                    id="Camera_parms"
                                    title={<div className="tab-header"><span>{t("Camera")}</span> </div>}
                                    panel=

                                    {selectedAnimal !== {} ? <WebNetCameraParms params_jdoc={selectedImagesThumbnailData[0]} /> : "No image selected"}
                                />

                            </Tabs>
                        </div>
                    </div> 
                : <div> 
                        <Button icon="property" onClick={() => handleOpenList()} title="Show patient list" ></Button>
                  </div>
                }
                
                <div id="RightDiv" className={openList || (openList && isExtendedImg) ? "RightDiv" : isExtendedImg ? "RightDivExtended" : "RightDiv"} >
                    <div id="sequenceImages" className="sequenceImages">
                        
                          <UploadImages {...thumbnailsDataConst} />
                        
                    </div>
                    <div id="loadedImage" className="loadedImage" >  
                        <MainImage classname="mainImage" imageNew={newImageState}
                            isActiveTempImage={isActiveTempImage} rois={roisArray} zoomValue={zoomValue}
                            visualImage={this.visualImage} imageSize={imageSize} isExtendedImg={isExtendedImg}
                            imBuffer={imBuffer}
                            calculateTemperatureValue={this.debouncedCalculateTemperatureValue}
                            isDraggable={this.state.isDraggable}
                            debouncedHandleResizeChange={this.debouncedHandleResizeChange}
                            notes={notesArray}
                            selectedROI={selectedROI} indexSelectedROI={indexSelectedROI}
                            isCelsius={isCelsius}
                            isCelsiusImg={isCelsiusImg}
                            
                        />
                        
                    </div> 

                    <div className="thermal">
                        <div className="mapColorSelect"> 
                            <Popup trigger={<button className="buttonCtrol" disabled={isVisualImage || imagePixels == null}> {t("Select")} <br /> {t("Colormap")} </button>} modal nested >
                                {close => (
                                    <div>
                                        <button className="close" onClick={close}> &times; </button>
                                        <ColorMaps apiCall={apiCall} colorMapSelected={colorMapSelected}
                                            handleColorMapSelected={handleColorMapSelected} fetchImage={fetchImage}
                                            colorMapList={colorMapList} />
                                    </div>
                                )}
                            </Popup>
                        </div>
                        <div className="termHrzlMaxBox">
                            <NumericInput className="bp4-fill" inputClassName="numericInput" disabled={!isActiveTempImage}
                                min={max_min}
                                max={max_max}
                                
                                defaultValue={max_value}
                                onValueChange={this.debouncedhandleValueChangeMax} 
                                asyncControl={true}
                                stepSize={0.1}
                                majorStepSize={5}
                                value={max_value}
                                selectAllOnFocus={true}

                            />
                            <div className="termHrzlMax"> 
                                <ThermometerHorsz id="termMax" posTemp={"maxTemp"} disabled={!isActiveTempImage || isVisualImage} min={min_value} max={max_max} posValue={max_value} handleValueChange={(e) => this.debouncedhandleValueChangeMax(e)} />
                            </div>
                        </div>
                        <div className= "thermometerColorMap">  
                            <ColorMapImagePreview imageNew={colorMapSelectedCode64.toString()} />
                            
                            <Thermometer className="thermometer" height="100%"
                                min={min_value} range={rangeValue} handleValueChangeMin={this.debouncedhandleValueChangeMin}
                                max={max_value} handleValueChangeMax={this.debouncedhandleValueChangeMax}
                                isImagePixelsLoaded={isImagePixelsLoaded}
                                isCelsius={isCelsius}
                                isCelsiusImg={isCelsiusImg}/>
                        </div>
                        <div className="termHrzlMinBox">
                            <div className="termHrzlMin"> 
                                <ThermometerHorsz id="termMin" posTemp={"minTemp"} disabled={!isActiveTempImage || isVisualImage} min={min_min} max={max_value} posValue={min_value} handleValueChange={(e) => this.debouncedhandleValueChangeMin(e)} />
                            </div>                      
                            <NumericInput className="bp4-fill" inputClassName="numericInput" disabled={!isActiveTempImage}
                                min={ min_min}
                                max={min_max}
                                
                                defaultValue={min_value}
                                onValueChange={this.debouncedhandleValueChangeMin}
                                asyncControl={true}
                                stepSize={0.1}
                                majorStepSize={5}
                                value={min_value}
                                selectAllOnFocus={true}                             
                            />
                        </div>

                        
                        <div className="zoomBox">
                            <ZoomSlider id="zoomSlider" posTemp={"zoomSlider"} disabled={!isImagePixelsLoaded} min={10}
                                max={500} zoomValue={zoomValue * 100} handleValueChange={(e) => { this.debouncedHandleResizeChange(e) }} />
                        </div>
                        <div className="ImageOptions">
                            {(!isVisualImage && hasVisualImage) ? <Button className="actionButton" icon="media" disabled={(imagePixels == null)} onClick={this.visualImage} title="Visual image" ></Button> : null}
                            {((isVisualImage && !isExtendedImg) || !hasVisualImage) ? <Button className="actionButton" icon="flash" disabled={!hasVisualImage} onClick={this.debouncedCalculateTemperatureValue} title="Thermal image" ></Button> : null}
                            
                            {/*<Button className="actionButtonText" text={this.iconTemp(isCelsius)} disabled={imagePixels == null || isVisualImage} onClick={this.setTempMeasure}*/}
                            {/*        title={isCelsiusImg ? "Clik to change to farh.\r\n for selected image" : "Clik to change to celsius\r\n  for selected image"} >*/}
                            {/*</Button>*/}
                                
                            {/*{!isCelsius ? <Button className="actionButtonText" text={this.iconTemp} disabled={(isVisualImage === true)} onClick={this.setTempMeasure} title={isCelsius ? "Clik to change to Farh." : "Clik to change to Celsius"} ></Button> : ""}*/}
                                
                            
                            <Button className="actionButton" icon="print" disabled={isVisualImage || imagePixels == null} onClick={this.openModal}></Button>
                            

                            <Button className="actionButton" icon="fullscreen" disabled={(imagePixels == null)} onClick={() => this.handleFullImageResizeChange()} title="Reset image size" ></Button>
                            <br />
                            {this.state.modalIsOpen ?
                                <ReportComment className="reportComment" handleReportPDF={this.handleReportPDF}
                                    comment={comment} handleReportComment={this.handleReportComment}
                                    reporter={reporter} handleReporter={this.handleReporter}
                                    modalIsOpen={this.state.modalIsOpen}
                                    closeModal={this.closeModal}
                                    reporter={reporter}
                                    t={t} />
                                : null
                            }
                            
                            <Checkbox className="draggable" disabled={!isImagePixelsLoaded} checked={this.state.isDraggable} label={t("Drag")} onChange={this.handleIsDraggable} />
                        
                            


                            
                                                   


                        </div>
                    </div> 
                </div>
                
            </div>                                  
        );
    }
}

export default withTranslation()(Viewer);

Viewer.propTypes = {


};
